<script>
import AddOppositeStreet from '@/modules/form-details/components/add-opposite-street/AddOppositeStreet.vue';
import { mapActions, mapGetters } from 'vuex';
import DatePicker from '@/components/datepicker/DatePicker.vue';
import { textShortener } from '@/libs/utils';

import FormPriceHeader from '@/modules/form-details/components/form-price-header/FormPriceHeader.vue';
import FormInvoiceData from '@/modules/form-details/components/form-invoice-data/FormInvoiceData.vue';
import FormPaymentMethods from '@/modules/form-details/components/form-payment-methods/FormPaymentMethods.vue';
import SecondForm from '@/modules/form-details/components/second-form/SecondForm.vue';
import { getEuropeanDate } from '../../libs/utils';
import SelectionPopup from '@/components/selection-popup/SelectionPopup.vue';

export default {
  name: 'FormDetails',
  components: {
    SecondForm,
    AddOppositeStreet,
    FormPaymentMethods,
    FormInvoiceData,
    FormPriceHeader,
    DatePicker,
    SelectionPopup
  },
  data() {
    return {
      isMobile: true,
      street: '',
      streetNumber: '',
      stateLength: '',
      showGenehmigungInfo: false
    };
  },

  created() {
    this.getTotalPriceAction();
  },
  mounted() {
    this.stateLength = this.formData.length;

    if(window.browoTracker && window.browoTracker.track){
      window.browoTracker.track('form_step_viewed', {
          step: 2,
          stepName: 'Bestellungs Details - Step 2',
          timestamp: new Date().toISOString()
      }, { immediate: true });
    } 
  },
  computed: {
    ...mapGetters([
      'formErrors',
      'priceInfo',
      'priceNotExists',
      'formData',
      'formSubmitted',
      'prices',
      'isFormDetailsEdit',
      'customer',
      'reasonOptions',
      'parentNameFirst'
    ]),
    getZipCodeCityAndPrice() {
      if (this.customer && (this.customer.bsr || this.customer.kuchenaktuell)) {
        return `Halteverbotszone in ${this.formData.zipCode} ${this.priceInfo.stadt}`;
      }
      let basePrice = 0;
      if (typeof this.prices !== 'undefined' && this.prices !== null) {
        if (typeof this.prices.basePrice !== 'undefined') {
          basePrice = this.prices.basePrice;
        }
      }

      let parentNameContent = '';
      if (this.parentNameFirst) {
        parentNameContent = `<span class="block small mb-5">(${this.parentNameFirst})</span>`;
      }
      return (
        `Halteverbotszone in ${this.formData.zipCode} ${this.priceInfo.stadt} <strong class="step2-price">${basePrice} €</strong>` +
        parentNameContent
      );
    }
  },
  methods: {
    ...mapActions([
      'getPriceInfoAction',
      'setExistsPriceAction',
      'getTotalPriceAction',
      'setFormDataAction',
      'updateFormErrorAction',
      'updateFormDataAction'
    ]),
    addForOppositeStreetTo: function(event) {
      this.formData.oppositeStreet = event.target.checked;
      this.setFormDataAction(this.formData);
    },
    consoleLog: function(args) {
      //console.log(args);
    },
    onInputChange: function(key, value) {
      this.updateFormDataAction({
        [key]: value
      });
      this.updateFormErrorAction({ firstForm: true });
      if (!(this.formData.street && this.formData.streetNr)) {
        this.updateFormErrorAction({ firstForm: false });
      }
    },
    onDateSelect: function(date, name) {
      if (!date) return;

      if (date && name) {
        if (!this.isFormDetailsEdit) {
          date = getEuropeanDate(date);
        }
      }

      let dateUpdateObject = {};

      if (name === 'dateFrom') {
        if (!this.formData || !this.formData.dateTo) {
          dateUpdateObject = {
            dateFrom: date,
            dateTo: date
          };
        } else {
          dateUpdateObject = {
            dateFrom: date
          };
        }
      } else {
        dateUpdateObject = {
          dateTo: date
        };
      }
      this.updateFormDataAction(dateUpdateObject);
    },
    getStandardLengths: function() {
      return this.priceInfo && this.priceInfo.standard_laenge ? this.priceInfo.standard_laenge : [];
    },
    textShortener,
    handleReasonChange: function(reason) {
      this.updateFormDataAction({ reason });
    },
    onGenehmigungChange: function(event) {
      this.updateFormDataAction({
        hasOwnPermit: event.target.checked
      });
    }
  }
};
</script>

<template>
  <div data-tracking-id="HV_GCLID_FORM2" class="form-details">
    <selection-popup pop-up-headline="Bitte wählen Sie den Ort aus" :zip-code="this.formData.zipCode" />
    <div class="container">
      <article class="col-lg-12 mb-25 mobile-show">
        <div id="content">
          <div class="row mb-5">
            <!-- PRICE ON TOP -->
            <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)" class="col-lg-12">
              <form-price-header />
            </div>
            <div class="col-md-6">
              <div class="panel panel-default panel-hv-grey">
                <div
                  v-if="formSubmitted && !(formErrors.firstForm && formErrors.secondForm && formErrors.formInvoice)"
                  class="form-error"
                >
                  <span>Bitte füllen Sie alle rot markierte Felder.</span>
                </div>
                <div class="panel-heading">
                  <i class="fa fa-pencil-square-o"></i> 1. Daten Ihrer Halteverbotszone(n):
                </div>
                <div class="panel-body ">
                  <strong v-html="getZipCodeCityAndPrice" />
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="mb-5">
                        <span>Vorlaufzeit mind. {{ priceInfo.bearbeitungsdauer }} Werktage</span>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="this.isFormDetailsEdit">
                      <table class="second-form-table">
                        <tbody>
                          <tr>
                            <td class="pr-5">
                              <date-picker
                                place-holder="von Datum"
                                input-id="form-date-from"
                                :value="formData.dateFrom"
                                name="dateFrom"
                                @onDateSelected="onDateSelect"
                                class-names="form-control"
                                :on-select="onDateSelect"
                              />
                            </td>
                            <td class="pl-5">
                              <date-picker
                                place-holder="bis Datum"
                                input-id="form-date-to"
                                :value="formData.dateTo || ''"
                                name="dateTo"
                                @onDateSelected="onDateSelect"
                                class-names="form-control"
                                :on-select="onDateSelect"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="!this.isFormDetailsEdit" class="col-sm-6 mb-5">
                      {{ formData.dateFrom }} bis {{ formData.dateTo }}<br />
                    </div>
                  </div>

                  <div class="row">
                    <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                      <div v-if="!('specific_prices' in prices)">
                        <div v-if="prices.days > 0 && !this.isFormDetailsEdit" class="col-sm-6 mb-xs-10">
                          <strong
                            >Zuschlag für Zusatztag pro Tag {{ prices.dailySurcharge }} € x
                            {{ prices.days }} Tag(e)</strong
                          >
                          <strong class="step2-price notranslate"> {{ prices.dailySurcharge * prices.days }} €</strong>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6" v-if="!this.isFormDetailsEdit">
                      <strong>Länge in m:</strong> {{ formData.length }} Meter

                      <div v-if="!customer || (customer && !customer.bsr && !customer.kuchenaktuell)">
                        <div v-if="!('specific_prices' in prices)">
                          <div v-if="!this.isFormDetailsEdit && prices.lengthSurcharge > 0" class="mb-15">
                            <strong
                              >Zuschlag für Extralänge pro Tag {{ prices.lengthSurcharge }} € x
                              {{ prices.days + 1 }} Tag(e)</strong
                            >
                            <strong class="hide-price step2-price"> {{ prices.totalLengthFee }} € </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="cixSelectBox " style="width:50%;" v-if="this.isFormDetailsEdit">
                    <div class="col-sm-6 pr-md-5 pr-sm-5 edit-length">
                      <select
                        class="stadt_laenge check-form2 form-control "
                        @change="
                          event => {
                            this.stateLength = event.target.value;
                            updateFormDataAction({
                              length: stateLength
                            });
                          }
                        "
                      >
                        <option v-if="getStandardLengths().length === 0" value="0">Länge in m</option>
                        <option
                          v-for="length in getStandardLengths()"
                          :selected="stateLength === length"
                          :key="length"
                          :value="length"
                        >
                          {{ length }} Meter
                        </option>
                        <option v-if="getStandardLengths().length > 0 && !isFormDetailsEdit" value=">25"
                          >Mehr als 25 Meter
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-10 important-info" v-if="priceInfo.info_feld">
                    <strong>Wichtige Information: </strong> <br />
                    <span style="white-space: pre-wrap;">{{ priceInfo.info_feld }}</span>
                  </div>
                  <div class="row">
                    <form id="vwo-hv-form-form-adress" @submit.prevent>
                      <div v-if="this.isFormDetailsEdit" class="col-md-12 reason-container">
                        <div class="mb-20">
                          <strong>Grund der Aufstellung:</strong>
                        </div>
                        <div>
                          <div
                            class="dropdown"
                            data-toggle="popover"
                            data-content=""
                            title=""
                            data-trigger="manual"
                            data-placement="bottom"
                            data-html="true"
                            data-original-title=""
                          >
                            <button
                              class="btn btn-default dropdown-toggle reason-toggle text-left"
                              type="button"
                              id="form-length"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="true"
                            >
                              {{ textShortener(formData.reason, 16) }}
                              <span class="fa fa-chevron-down" />
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="form-length">
                              <li v-for="reason in this.reasonOptions" :key="reason">
                                <a @click="handleReasonChange(reason)" href="javascript:void(0)">
                                  {{ reason }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div v-if="!this.isFormDetailsEdit" class="col-md-12">
                        <div class="mb-20">
                          <strong>Grund der Aufstellung:</strong>
                          <br />
                          {{ formData.reason }}
                        </div>
                      </div>

                      <div class="clear"></div>
                      <div class="col-lg-6">
                        <strong>*Adresse der Halteverbotszone:</strong>
                        <table class="second-form-table">
                          <tbody>
                            <tr>
                              <td class="pr-5">
                                <input
                                  @input="event => (street = event.target.value)"
                                  @change="onInputChange('street', street)"
                                  :value="formData.street"
                                  type="text"
                                  v-bind:class="
                                    formSubmitted && !formData.street
                                      ? 'form-control check-form2 error '
                                      : 'form-control check-form2'
                                  "
                                  placeholder="Straße"
                                  required=""
                                />
                              </td>
                              <td class="pl-5">
                                <input
                                  v-bind:class="
                                    formSubmitted && !formData.streetNr
                                      ? 'form-control check-form2 error '
                                      : 'form-control check-form2'
                                  "
                                  type="text"
                                  style="text-align: center;"
                                  class="form-control"
                                  placeholder="Nr."
                                  :value="formData.streetNr"
                                  @input="event => (streetNumber = event.target.value)"
                                  @change="onInputChange('streetNr', streetNumber)"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="col-lg-6">
                        <div class="hide_inputs_I">
                          <strong>Uhrzeit:</strong>
                          <table class="second-form-table">
                            <tbody>
                              <tr>
                                <td class="pr-5">
                                  <div class="cixSelectBox pull-left mr-10 pull-left">
                                    <select
                                      v-if="!customer || (customer && !customer.bsr)"
                                      class="form-control"
                                      @change="
                                        event =>
                                          updateFormDataAction({
                                            timeStart: event.target.value
                                          })
                                      "
                                    >
                                      <option value="06:00">06:00</option>
                                      <option selected="selected" value="07:00">07:00</option>
                                      <option value="08:00">08:00</option>
                                      <option value="09:00">09:00</option>
                                      <option value="10:00">10:00</option>
                                      <option value="11:00">11:00</option>
                                      <option value="12:00">12:00</option>
                                      <option value="13:00">13:00</option>
                                      <option value="14:00">14:00</option>
                                      <option value="15:00">15:00</option>
                                      <option value="16:00">16:00</option>
                                    </select>

                                    <select v-else>
                                      class="form-control" @change=" event => updateFormDataAction({ timeStart:
                                      event.target.value }) " >
                                      <option value="06:00">06:00</option>
                                      <option value="07:00">07:00</option>
                                      <option value="08:00">08:00</option>
                                      <option value="09:00">09:00</option>
                                      <option value="10:00">10:00</option>
                                      <option value="11:00">11:00</option>
                                      <option value="12:00">12:00</option>
                                      <option value="13:00">13:00</option>
                                      <option value="14:00">14:00</option>
                                      <option value="15:00">15:00</option>
                                      <option value="16:00">16:00</option>
                                      <option value="17:00">17:00</option>
                                      <option value="18:00">18:00</option>
                                      <option value="19:00">19:00</option>
                                      <option value="20:00">20:00</option>
                                    </select>
                                  </div>
                                </td>
                                <td class="pl-5">
                                  <div class="cixSelectBox pull-right">
                                    <select
                                      v-if="!customer || (customer && !customer.bsr)"
                                      style="width: 120% !important;"
                                      class="form-control"
                                      @change="
                                        event =>
                                          updateFormDataAction({
                                            timeEnd: event.target.value
                                          })
                                      "
                                    >
                                      <option value="17:00">17:00</option>
                                      <option value="18:00">18:00</option>
                                      <option value="19:00">19:00</option>
                                      <option value="20:00">20:00</option>
                                      <option value="21:00">21:00</option>
                                      <option value="22:00">22:00</option>
                                    </select>

                                    <select
                                      v-else
                                      style="width: 120% !important;"
                                      class="form-control"
                                      @change="
                                        event =>
                                          updateFormDataAction({
                                            timeEnd: event.target.value
                                          })
                                      "
                                    >
                                      <option value="06:00">06:00</option>
                                      <option value="07:00">07:00</option>
                                      <option value="08:00">08:00</option>
                                      <option value="09:00">09:00</option>
                                      <option value="10:00">10:00</option>
                                      <option value="11:00">11:00</option>
                                      <option value="12:00">12:00</option>
                                      <option value="13:00">13:00</option>
                                      <option value="14:00">14:00</option>
                                      <option value="15:00">15:00</option>
                                      <option value="16:00">16:00</option>
                                      <option value="17:00">17:00</option>
                                      <option value="18:00">18:00</option>
                                      <option value="19:00">19:00</option>
                                      <option value="20:00">20:00</option>
                                      <option value="21:00">21:00</option>
                                      <option value="22:00">22:00</option>
                                    </select>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="col-md-12 mb-10 mt-10">
                        <input
                          type="checkbox"
                          id="genehmigung-checkbox"
                          @change="onGenehmigungChange"
                          :checked="formData.hasOwnPermit"
                        />
                        <label for="genehmigung-checkbox"><strong>Ich habe bereits eine Genehmigung</strong></label>
                        <div
                          class="genehmigung-info"
                          @mouseover="showGenehmigungInfo = true"
                          @mouseout="showGenehmigungInfo = false"
                        >
                          <div class="badge-fa">
                            <i class="fa fa-info" />
                          </div>
                          <div v-if="showGenehmigungInfo" class="genehmigung-popup">
                            <div class="arrow"></div>
                            <h3 class="popover-title">Verkehrsrechtliche Anordnung</h3>
                            <div class="popover-content">
                              Verkehrsrechtliche Anordnung für das Stellen von Halteverbotszonen wurde bei der
                              jeweiligen Stadt- oder Gemeindeverwaltung beantragt und liegt vor. Hineweis: Ohne
                              Genehmigung ist die Halteverbotszone ungültig und nicht nutzbar!
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="clear"></div>
                      <div class="col-md-12">
                        <add-opposite-street
                          v-if="priceInfo.beidseitig_aufstellung"
                          :on-checked="addForOppositeStreetTo"
                          :pop-up-text="priceInfo.beschreibung"
                          check-box-id="opposite-street-level-1"
                          :price="priceInfo.genehmigung_brutto"
                          :fill="this.formData.oppositeStreet"
                        />
                        <second-form />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <form-invoice-data />
            <form-payment-methods />
            <div class="clear"></div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<!-- css for component styles -->
<style scoped lang="scss"></style>

<!-- css for global styles -->
<style lang="scss">
@import 'FormDetailsStyles';
</style>
